import Datatable from "../../Components/Datatable"
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";

export const AdminUserList = () => {
    const [data, setData] = useState([]);
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation()



    const columns = React.useMemo(
        () => [
            {
                Header: t("id"),
                Footer: t("id"),
                accessor: 'id',
            },
            {
                Header: t("namesurname"),
                Footer: t("namesurname"),
                accessor: 'name',
            },

            {
                Header: t("schoolId"),
                Footer: t("schoolId"),
                accessor: 'SchoolId',
            },
            {
                Header: t("createdAt"),
                Footer: t("createdAt"),
                accessor: 'createdAt',
            },
            {
                Header: t("expiryDate"),
                Footer: t("expiryDate"),
                accessor: 'expiryDate',
            },
            {
                Header: t("sectionName"),
                Footer: t("sectionName"),
                accessor: 'sectionName',
            },
            {
                Header: t("isActive"),
                Footer: t("isActive"),
                accessor: 'isTrial',
            },
            {
                Header: t("editUser"),
                accessor: (originalRow, rowIndex) => (
                    <div className="d-flex  align-items-center">
                        <button
                            className="btn btn-warning mr-2  btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            {t("edit")}
                        </button>
                    </div>
                ),
                id: 'actionEdit',
                Footer: t("editUser"),
            },
            {
                Header: "egitim",
                Footer: "egitim",
                accessor: "egitim",
            },
            {
                Header: "egitim duzenle",
                accessor: (originalRow, rowIndex) => (
                    <div className="d-flex  align-items-center">
                        <button
                            className="btn btn-warning mr-2  btn-sm"
                            onClick={() => handleEditEducational(originalRow)}
                        >
                            {t("edit")}
                        </button>
                    </div>
                ),
                id: 'actionEditEducational',
                Footer: "egitim duzenle",
            },
        ],
        [],
    )

    const handleEdit = (row) => {
        window.location.href = "/admin/edituser/" + row['id'];
    }

    const handleEditEducational = (row) => {
        window.location.href = "/admin/editusereducational/" + row['id'];
    }
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = "https://api.heryerdeingilizce.com/api/admin/User/GetUsers";
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            console.log(res.data['data']);
                            console.log(res.data['data']);

                            for (let i = 0; i < res.data['data'].length; i++) {
                                console.log(typeof (res.data['data'][i]['educational']));
                                let a = ""
                                if (res.data['data'][i]['user']['isTrial']) {
                                    a = t('passive')
                                }
                                else {
                                    a = t('active')
                                }
                                if (res.data['data'][i]['user']['isStudent']) {
                                    if (res.data['data'][i]['user']['isInvidual']) {
                                        const d = new Date(res.data.data[i].user.expiryDate);
                                        const expiryDateTR = d.toLocaleDateString("tr-TR");
                                        const dd = new Date(res.data.data[i].user.createdAt);
                                        const createdDataTR = dd.toLocaleDateString("tr-TR");
                                        data.push({
                                            "id": res.data['data'][i]['user']['id'],
                                            "name": res.data['data'][i]['user']['fullName'],
                                            "email": res.data['data'][i]['user']['username'],
                                            "SchoolId": res.data['data'][i]['detail']['schoolId'],
                                            "isTrial": a,
                                            "expiryDate": expiryDateTR,
                                            "createdAt": createdDataTR,
                                            "sectionName": res.data['data'][i]['detail']['sectionName'],
                                            "egitim": JSON.stringify(res.data['data'][i]['educational'])
                                        })
                                    }
                                }
                            }
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoading(false);
        }
        fetchData();

    }, []);

    return (
        <div>
            <div style={{ textAlign: "center" }}>
                <h1>{t('userList')}</h1>
            </div>
            <span>egitim kısmında ki courseId yazan değer, üyenin aktif kursunun idsini.. subjecti aktif subjectini.. content id ise o subject deki hangi soruda olduğunu göstermektedir.. <b>null</b> ise düzenle kısmında girip belirlenmelidir.</span>
            <h4>{msg}</h4>
            {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}

            {!loading && (
                <div>
                    <Datatable data={data} columns={columns} tableBaslik={t('userList')} />
                </div>
            )}
        </div>
    );
};
export default AdminUserList;
